module.exports = __webpack_public_path__ + "img/icon_send.631eb264.svg";